module.exports = __webpack_public_path__ + "img/vault.07b5a1dc.svg";